export enum TriggerTypes {
  CHAT_ENDED_TRIGGER = 'chatEndedTrigger',
  DAILY_REFRESH = 'dailyRefresh',
  WEEKLY_REFRESH = 'weeklyRefresh',
  CONVERSION_AMOUNT_TRIGGER = 'conversionAmountTrigger',
  CONVERSION_COUNT_TRIGGER = 'conversionCountTrigger',
  SURVEY_NPS_TRIGGER = 'surveyNpsTrigger',
  SURVEY_KNOWLEDGE_TRIGGER = 'surveyKnowledgeTrigger',
  SURVEY_PROFESSIONALISM_TRIGGER = 'surveyProfessionalismTrigger',
  SURVEY_OVERALL_TRIGGER = 'surveyOverallTrigger',
  SURVEY_RESPONSIVENESS_TRIGGER = 'surveyResponsivenessTrigger'
}

export enum SourceTypes {
  GET_CHAT_CLOSED_COUNT_OBSERVABLE = 'getChatClosedCountObservable',
  CONVERSION_AMOUNT_OBSERVABLE = 'conversionAmountObservable',
  CONVERSION_COUNT_OBSERVABLE = 'conversionCountObservable',
  SURVEY_NPS_OBSERVABLE = 'surveyNpsObservable',
  SURVEY_KNOWLEDGE_OBSERVABLE = 'surveyKnowledgeObservable',
  SURVEY_PROFESSIONALISM_OBSERVABLE = 'surveyProfessionalismObservable',
  SURVEY_OVERALL_OBSERVABLE = 'surveyOverallObservable',
  SURVEY_RESPONSIVENESS_OBSERVABLE = 'surveyResponsivenessObservable'
}

export const agentStatConfig = {
  NUMBER_OF_CLOSED_CHATS: {
    triggers: [TriggerTypes.CHAT_ENDED_TRIGGER],
    source: SourceTypes.GET_CHAT_CLOSED_COUNT_OBSERVABLE
  },
  CONVERSION_AMOUNT: {
    triggers: [TriggerTypes.CONVERSION_AMOUNT_TRIGGER],
    source: SourceTypes.CONVERSION_AMOUNT_OBSERVABLE
  },
  CONVERSION_COUNT: {
    triggers: [TriggerTypes.CONVERSION_COUNT_TRIGGER],
    source: SourceTypes.CONVERSION_COUNT_OBSERVABLE
  },
  SURVEY_NPS: {
    triggers: [TriggerTypes.SURVEY_NPS_TRIGGER],
    source: SourceTypes.SURVEY_NPS_OBSERVABLE
  },
  SURVEY_KNOWLEDGE: {
    triggers: [TriggerTypes.SURVEY_KNOWLEDGE_TRIGGER],
    source: SourceTypes.SURVEY_KNOWLEDGE_OBSERVABLE
  },
  SURVEY_PROFESSIONALISM: {
    triggers: [TriggerTypes.SURVEY_PROFESSIONALISM_TRIGGER],
    source: SourceTypes.SURVEY_PROFESSIONALISM_OBSERVABLE
  },
  SURVEY_JUST_OVERALL: {
    triggers: [TriggerTypes.SURVEY_OVERALL_TRIGGER],
    source: SourceTypes.SURVEY_OVERALL_OBSERVABLE
  },
  SURVEY_RESPONSIVENESS: {
    triggers: [TriggerTypes.SURVEY_RESPONSIVENESS_TRIGGER],
    source: SourceTypes.SURVEY_RESPONSIVENESS_OBSERVABLE
  }
};
